import { useNavigate } from "react-router";

import useRecordProduct from "../../../../../clients/products/useRecordProduct";
import useCanEditBrand from "../../../../../clients/users/useCanEditBrand";
import useNotifications, { notifyMutationErrors } from "../../../../../components/Notifications";

export default function useProductSaver(product, data) {
    const [record] = useRecordProduct(
        product
            ? {
                brand: {
                    id: product?.data?.brand?.id,
                },
                naturalKey: product?.metadata?.naturalKey,
            }
            : {
                brand: {
                    id: data?.data?.brand?.id,
                },
                naturalKey: data?.metadata?.naturalKey,
            },
        data !== undefined ? JSON.parse(
            JSON.stringify(data),
            function (key, value) {
                if (key === "__id") return undefined;
                return value;
            },
        ) : undefined,
    );

    const navigate = useNavigate();
    const notifications = useNotifications();

    const canEditSourceBrand = useCanEditBrand(product?.data?.brand?.id);
    const canEditTargetBrand = useCanEditBrand(data?.data?.brand?.id);
    const canEdit = product
        ? canEditSourceBrand && canEditTargetBrand
        : canEditTargetBrand;
    if (!canEdit) return () => {};

    return async function save() {
        let result;

        try {
            result = await record();
        } catch (error) {
            notifications.error((error as Error)?.message ?? "The product could not be saved.");
            return;
        }

        const errors = result.data?.recordProduct?.errors ?? [];
        if (errors.length) {
            notifyMutationErrors(notifications, errors);
            return;
        }

        if (!product) {
            notifications.success("Your product was created.");
            navigate(`../${ result.data.recordProduct.product.id.replaceAll("-", "") }`);
        } else {
            notifications.success("Your changes were saved. Reload the page to see them.");
        }
    };
}
